document.addEventListener('DOMContentLoaded', function () {
    const categoryItems = document.querySelectorAll('.blog-category-item');
    const posts = document.querySelectorAll('.blog-post-item');
  
    categoryItems.forEach(item => {
      item.addEventListener('click', function () {
        // Remove 'active' class from all categories
        categoryItems.forEach(i => i.classList.remove('active'));
        // Add 'active' class to the clicked category
        item.classList.add('active');
  
        const selectedCategoryId = item.getAttribute('data-category-id');
  
        posts.forEach(post => {
          const postCategoryIds = post.getAttribute('data-category-id').split(' ');
  
          if (selectedCategoryId === 'all' || postCategoryIds.includes(selectedCategoryId)) {
            post.style.display = 'block';
          } else {
            post.style.display = 'none';
          }
        });
      });
    });
  });
  